import { isAxiosError } from 'axios'
import { api } from '@/api'
import type { GameRecord, PlayerIdentity } from '@/game/storage'

export type Period = 'day' | 'week' | 'all'

export interface LeaderboardEntry {
  rank: number
  nickname: string
  score: number
  is_me: boolean
}

export interface Leaderboard {
  period: Period
  entries: LeaderboardEntry[]
  /** Своё место за период; null — без токена или без партий за период. */
  me: { rank: number; score: number } | null
}

/** Ник: те же правила, что на сервере (PlayerRequest), — чтобы не гонять заведомо плохой. */
export const NICKNAME_PATTERN = /^[\p{L}\p{N} _.-]{2,20}$/u

export function normalizeNickname(raw: string): string {
  return raw.trim().replace(/\s+/g, ' ')
}

function auth(token: string | undefined) {
  return token ? { Authorization: `Bearer ${token}` } : {}
}

/** HTTP-статус ошибки запроса; null — ответа не было (нет сети, таймаут, CORS). */
export function httpStatus(error: unknown): number | null {
  return isAxiosError(error) ? (error.response?.status ?? null) : null
}

export async function createPlayer(nickname: string): Promise<PlayerIdentity> {
  const { data } = await api.post<PlayerIdentity>('/players', { nickname })
  return { id: data.id, nickname: data.nickname, token: data.token }
}

export async function renamePlayer(token: string, nickname: string): Promise<string> {
  const { data } = await api.patch<{ nickname: string }>(
    '/players/me',
    { nickname },
    { headers: auth(token) },
  )
  return data.nickname
}

export async function postResult(token: string, record: GameRecord): Promise<void> {
  await api.post(
    '/results',
    {
      client_id: record.id,
      score: record.score,
      hits: record.hits,
      duration: record.duration,
      played_at: record.playedAt,
    },
    { headers: auth(token) },
  )
}

export async function fetchLeaderboard(period: Period, token?: string): Promise<Leaderboard> {
  const { data } = await api.get<Leaderboard>('/leaderboard', {
    params: { period },
    headers: auth(token),
  })
  return data
}
